module.exports = __webpack_public_path__ + "img/_blog9.518a2840.jpg";